// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueHead from 'vue-head'
import { Select, Option, OptionGroup } from 'element-ui';
import 'select2/dist/js/select2.full';
import Paginate from 'vuejs-paginate';
import ToggleButton from 'vue-js-toggle-button';

import i18n from '@/plugins/i18n'
import '@grubersjoe/slide-menu/dist/slide-menu.js';

Vue.use(VueAxios, axios);
Vue.use(VueHead);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(ToggleButton);
Vue.component('paginate', Paginate);

Vue.config.productionTip = false;

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
});

